import { useEffect, useState } from "react";
import http from "services/httpService";

function useFetchEnrolment() {
  const [enrolments, setEnrolments] = useState();
  const [loading, setLoading] = useState(true);

  const fetchEnrolments = async () => {
    try {
      setLoading(true);
      const { data } = await http.get(
        "/business/get_payment_summary/"
      );
      setEnrolments(data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEnrolments();
  }, []);

  return {
    enrolments,
    loading,
  };
}

export default useFetchEnrolment;
